export default __webpack_public_path__ + "static/media/day_trado_success_active_account_and_plataform_bc_2.6e24f727.png";